import React from "react";
import "../style/About.css";
import "../style/Common.css";
import aboutUs from "../images/More.jpg";
import "../style/More.css";
import Services from "./Services";

const OurServices = () => {
  return (
    <section className="more" id="more">
      <div className="about-us-container">
        <div className="about-us-content">
          <h1>Our Services</h1>
          <nav className="breadcrumb">
            <span>Our Services</span>
            <span className="separator">|</span>
            <span>About Us</span>
          </nav>
        </div>
        <div className="about-us-image">
          <img src={aboutUs} alt="About Us" />
        </div>
      </div>
      <Services AdditionalSlides={true} />
    </section>
  );
};

export default OurServices;
